import React from 'react';
import Head from 'next/head';
import TermsAndConditions from '@features/common/components/TermsAndConditions';
import { useIntl } from 'react-intl';
import { GetServerSideProps } from 'next';
import { IGetServerSideProps } from 'model/global.model';

const TermsAndConditionsPage = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Title-T&C' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<TermsAndConditions />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Общи условия | Gamy.fun',
		},
	};
};

export default TermsAndConditionsPage;
